import { IIndexable } from 'core-ts-types';

export class ScheduleTerm implements IIndexable {
  id: number;
  nk: string;
  name: string;
  cat_yr: number;
  term_start_dt: moment.Moment;
  term_end_dt: moment.Moment;
  registration_start_dt: moment.Moment;
  registration_end_dt: moment.Moment;
  rank: number;

  constructor(term: Partial<ScheduleTerm>) {
    term.term_start_dt = moment(term.term_start_dt as moment.Moment);
    term.term_end_dt = moment(term.term_end_dt as moment.Moment);
    term.registration_start_dt = moment(term.registration_start_dt as moment.Moment);
    term.registration_end_dt = moment(term.registration_end_dt as moment.Moment);

    _.merge(this, term);
  }

  static build(term: Partial<ScheduleTerm>): ScheduleTerm {
    return new ScheduleTerm(term);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/builders/schedule_terms_builder.ts